import rebuildSite from "features/adminDashboard/actions/update/update.rebuildSite";
import { useState } from "react";
import { BiRocket } from "react-icons/bi";
import { useDispatch } from "services/redux/rootReducer";
import styled, { css } from "styled-components";

import LogContainer from "./logContainer";

const DeployConfig = () => {
    const dispatch = useDispatch();
    const [requestCalled, setRequestCalled] = useState<boolean>(false);

    const handleDeploy = async () => {
        setRequestCalled(true);
        await dispatch(rebuildSite());
        setRequestCalled(false);
    };

    return (
        <Container>
            <Heading>
                <BiRocket />
                <span>Deployments</span>
            </Heading>
            <Content>
                <Card>
                    <span>CONTROL PANEL</span>
                    <div>
                        <DeployButton
                            disabled={requestCalled}
                            onClick={() => handleDeploy()}
                        >
                            Deploy{requestCalled ? "ing..." : ""}
                        </DeployButton>
                    </div>
                </Card>
                <Card>
                    <span>DEPLOYMENT LOGS</span>
                    <LogContainer />
                </Card>
            </Content>
        </Container>
    );
};

const FlexCenter = css`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Container = styled.div`
    display: flex;
    flex-flow: column;
    overflow-y: auto;

    border-radius: 0.2rem;

    & > *:first-child {
        flex: 1 0 20%;
    }

    & > *:last-child {
        flex: 1 0 80%;
    }
`;

const Heading = styled.div`
    ${FlexCenter}

    font-size: 1.5rem;
    font-weight: ${(props) => props.theme.fontWeight.bolder};

    user-select: none;

    & > *:first-child {
        margin-right: 10px;
    }
`;

const Content = styled.div``;

const Card = styled.div`
    display: flex;
    height: 45%;

    padding-bottom: 20px;

    flex-flow: column;
    align-items: center;

    & > *:first-child {
        flex: 1.5;
        font-size: 0.9rem;
        font-weight: ${(props) => props.theme.fontWeight.bolder};
        color: ${(props) => props.theme.colors.primary[400]};
        user-select: none;

        ${FlexCenter}
    }

    & > *:last-child {
        flex: 4.5;
        ${FlexCenter}
    }

    @media (max-width: 768px) {
        padding-bottom: 0;

        & > *:first-child {
            padding-bottom: 20px;
        }
    }
`;

const DeployButton = styled.div<{ disabled?: boolean }>`
    ${FlexCenter}

    background: ${(props) =>
        props.disabled ? "lightgray" : props.theme.colors.primary[500]};

    transition: all 0.1s ease 0s;
    color: ${(props) => props.theme.colors.neutral[100]};
    box-shadow: 0px 8px 15px rgba(57, 120, 198, 0.15);

    user-select: none;

    width: 10vw;
    height: 3.2vw;
    min-width: 8rem;
    min-height: 3.2rem;

    border-radius: 0.2rem;

    font-size: 1.2rem;
    font-weight: ${(props) => props.theme.fontWeight.bold};

    ${(props) =>
        !props.disabled &&
        css`
            &:hover {
                cursor: pointer;
                transform: scale(1.02);
                background: ${(props) => props.theme.colors.primary[400]};
            }
        `}
`;

export default DeployConfig;
